var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckMarkWithBlueBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.90476,
    cy: 8.09535,
    r: 5.66667,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 0C3.81328 0 0 3.81328 0 8.5C0 13.1867 3.81328 17 8.5 17C13.1867 17 17 13.1867 17 8.5C17 3.81328 13.1867 0 8.5 0ZM13.2506 6.26316L7.8183 11.6529C7.49875 11.9724 6.98747 11.9937 6.64662 11.6742L3.77068 9.05389C3.42982 8.73434 3.40852 8.20175 3.70677 7.8609C4.02632 7.52005 4.5589 7.49875 4.89975 7.8183L7.1792 9.90602L12.0363 5.04887C12.3772 4.70802 12.9098 4.70802 13.2506 5.04887C13.5915 5.38972 13.5915 5.92231 13.2506 6.26316Z",
    fill: "#5271FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMarkWithBlueBg);
export default __webpack_public_path__ + "static/media/check-mark-with-blue-bg.41593a7beb753db7467c61713ff8f998.svg";
export { ForwardRef as ReactComponent };